import { FC } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@features/ui';
import { TCouponCode } from '@src/types';

interface EditCodeFormProps {
  open: boolean;
  code: TCouponCode | null;
  onOpenChange: (open: boolean) => void;
}

export const EditCodeForm: FC<EditCodeFormProps> = ({
  open,
  code,
  onOpenChange,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="lg">
        <DialogHeader>
          <DialogTitle>Edit Coupon Code</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="rounded-md bg-yellow-50 border border-yellow-200 p-3 text-sm text-yellow-800">
            The edit API is not yet available. This is a placeholder UI.
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Code</label>
            <input
              readOnly
              className="border border-gray-300 rounded px-3 py-2 w-full bg-gray-50"
              value={code?.code ?? ''}
            />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button
              size="sm"
              variant="secondary"
              onClick={() => onOpenChange(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
